import { z } from 'zod';
import { UserProfileSchema } from './user.js';
export const TelegramLoginRequestSchema = z.object({
    initData: z.string().min(1, 'initData is required'),
});
export const AuthResponseSchema = z.object({
    user: UserProfileSchema,
    token: z.string().min(1),
});
export const ApiErrorSchema = z.object({
    error: z.string(),
    details: z.unknown().optional(),
});
